import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { getUserInfo } from '..'
import { UserQueryKeys } from '../queryKeys'

export const useGetUserInfo = (options?: Omit<UseQueryOptions<UserInfo>, 'queryKey'>) => {
  return useQuery({
    queryKey: UserQueryKeys.GetUserInfo(),
    queryFn: ({ signal }) => getUserInfo({ signal }),
    staleTime: Infinity,
    ...options
  })
}
